import React from "react";

const overlayStyle = {
  position: "fixed",
  top: 0, left: 0, right: 0, bottom: 0,
  background: "rgba(0,0,0,0.17)",
  zIndex: 1000,
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
};

const boxStyle = {
  background: "#fff",
  borderRadius: 14,
  padding: "37px 30px 30px 30px",
  width: "90%",
  maxWidth: 370,
  textAlign: "center",
  boxShadow: "0 7px 28px rgba(25,56,119,.12)",
  position: "relative",
};

const checkCircleStyle = {
  background: "#c9f2e0",
  width: 58,
  height: 58,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  margin: "0 auto 22px auto",
  borderRadius: "50%",
  flexShrink: 0,
};

const buttonStyle = {
  width: "100%",
  marginTop: 30,
  background: "#2684ff",
  color: "white",
  border: "none",
  borderRadius: 8,
  padding: "14px 0",
  fontSize: "1.1rem",
  fontWeight: 600,
  cursor: "pointer",
  transition: "background 0.2s",
};

export default function SubmissionSuccessModal({ candidateName, job, highScore, onClose, onContinue }) {
  // Debug logs to check prop values on each render
  console.log("SubmissionSuccessModal Render:", { highScore, candidateName, job });

  return (
    <div style={overlayStyle} onClick={onClose} aria-modal="true" role="dialog" tabIndex={-1}>
      <div style={boxStyle} onClick={e => e.stopPropagation()}>
        <button
          aria-label="Close"
          onClick={onClose}
          style={{
            position: "absolute",
            top: 15,
            right: 15,
            fontSize: 22,
            border: "none",
            background: "transparent",
            cursor: "pointer",
            color: "#93aac7",
          }}
        >
          ×
        </button>
        <div style={checkCircleStyle}>
          <svg width={32} height={32} viewBox="0 0 46 46">
            <circle cx={23} cy={23} r={23} fill="#22ba73" />
            <path d="M13 24.5l6.8 6 13-13" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
        <h2 style={{ margin: "0 0 10px", color: "#223356", fontSize: "1.4rem", fontWeight: 700 }}>
          Application Submitted!
        </h2>
        {highScore ? (
          <>
            <p style={{ margin: 0, color: "#647295", fontSize: "1rem" }}>
              {candidateName ? `${candidateName}, ` : ""}
              Thank you for applying to <strong>{job?.jobrole ?? ""}</strong>.
              Congratulations!, you are invited to the interview chat.
            </p>
            <button style={buttonStyle} onClick={onContinue} type="button">
              Continue to Interview
            </button>
          </>
        ) : (
          <p style={{ margin: 0, color: "#647295", fontSize: "1rem" }}>
            {candidateName ? `${candidateName}, ` : ""}
            Thank you for applying for the <strong>{job?.jobrole ?? ""}</strong> position.
            <br />
            While your background isn't the ideal fit for this specific opportunity, we see potential in your profile. We will be saving your information and will reach out if a new role is created or opens up that better utilizes your unique experience. Please stay connected and continue to check our careers page for updates.
          </p>
        )}
      </div>
    </div>
  );
}
